import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssueDownloadUrlInput,
  CreateIssueDownloadUrlResponse,
  QueryCreateDispatchIssueDocumentDownloadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateDispatchIssueDocumentDownloadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssueDownloadUrlInput]?: CreateIssueDownloadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse>;
}

// SearchDispatchIssueDocument Service
export const {
  createDispatchIssueDocumentDownloadUrl,
  recreateDispatchIssueDocumentDownloadUrl,
  useCreateDispatchIssueDocumentDownloadUrl,
} = ((): {
  createDispatchIssueDocumentDownloadUrl: ServiceMethod;
  recreateDispatchIssueDocumentDownloadUrl: ServiceMethod;
  useCreateDispatchIssueDocumentDownloadUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(CreateDispatchIssueDocumentDownloadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssueDownloadUrlInput, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse> => {
        const args: QueryCreateDispatchIssueDocumentDownloadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createDispatchIssueDocumentDownloadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createDispatchIssueDocumentDownloadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchIssueDocumentDownloadUrl: fetch,
    recreateDispatchIssueDocumentDownloadUrl: refetch,
    useCreateDispatchIssueDocumentDownloadUrl: useService,
  };
})();
